import { PrimaryButton } from "../button";
import { LINK_STYLES, ACTION_BUTTON } from "./plenary-download";

interface StepActionsProps {
  cancelLabel: string;
  cancelDisabled?: boolean;
  handleCancel: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  handleNext?: () => void;
}

export function StepActions({
  cancelLabel,
  cancelDisabled = false,
  handleCancel,
  nextLabel,
  nextDisabled = false,
  handleNext,
}: StepActionsProps) {
  return (
    <div className="flex items-center justify-between gap-4 mt-4 overflow-x-hidden">
      <button type="button" className={`${LINK_STYLES} py-2`} disabled={cancelDisabled} onClick={handleCancel}>
        {cancelLabel}
      </button>
      {!!nextLabel && (
        <PrimaryButton
          type={handleNext ? "button" : "submit"}
          className={ACTION_BUTTON}
          disabled={nextDisabled}
          onClick={handleNext}
        >
          {nextLabel}
        </PrimaryButton>
      )}
    </div>
  );
}
